import {
  AppBar, Toolbar, IconButton, Typography, Box, Avatar, Menu, MenuItem, Divider, Tooltip,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useThemeMode } from '../../context/ThemeContext';
import { useAuth } from '../../context/AuthContext';
import { APP_NAME } from '../../config/constants';
import { DRAWER_WIDTH } from './Sidebar';
import { ROLE_LABELS } from '../../config/roles';

export const TopBar = ({ sidebarOpen, onToggleSidebar }) => {
  const { mode, toggleMode } = useThemeMode();
  const { user, role, logout } = useAuth();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const initials = user?.fullName
    ? user.fullName.split(' ').map((n) => n[0]).join('').slice(0, 2).toUpperCase()
    : '?';

  const handleLogout = async () => {
    setAnchorEl(null);
    await logout();
    navigate('/login');
  };

  const headerTitle = user?.companyName
    ? `${APP_NAME} - ${user.companyName}`
    : APP_NAME;

  return (
    <AppBar position="fixed" elevation={0}
      sx={{
        width: { md: sidebarOpen ? `calc(100% - ${DRAWER_WIDTH}px)` : '100%' },
        ml: { md: sidebarOpen ? `${DRAWER_WIDTH}px` : 0 },
        transition: 'width 0.2s, margin 0.2s',
        bgcolor: 'background.paper', color: 'text.primary', borderBottom: 1, borderColor: 'divider',
      }}>
      <Toolbar>
        <IconButton edge="start" onClick={onToggleSidebar} sx={{ mr: 1 }}><MenuIcon /></IconButton>
        <Tooltip title={headerTitle}>
          <Typography
            variant="h6"
            noWrap
            sx={{
              flexGrow: 1,
              minWidth: 0,
              fontWeight: 600,
              display: { xs: 'none', sm: 'block' },
            }}
          >
            {headerTitle}
          </Typography>
        </Tooltip>

        {role && (
          <Typography variant="caption" sx={{ mr: 2, display: { xs: 'none', md: 'block' }, color: 'text.secondary' }}>
            {ROLE_LABELS[role] || role}
          </Typography>
        )}

        <Tooltip title={mode === 'light' ? 'Dark mode' : 'Light mode'}>
          <IconButton onClick={toggleMode} color="inherit">
            {mode === 'light' ? <Brightness4Icon /> : <Brightness7Icon />}
          </IconButton>
        </Tooltip>

        <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
          <Avatar sx={{ width: 34, height: 34, bgcolor: 'primary.main', fontSize: 14 }}>{initials}</Avatar>
        </IconButton>

        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }} anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
          <Box sx={{ px: 2, py: 1 }}>
            <Typography variant="subtitle2" fontWeight={600}>{user?.fullName}</Typography>
            <Typography variant="caption" color="text.secondary">{user?.email}</Typography>
            {role && <Typography variant="caption" display="block" color="primary">{ROLE_LABELS[role]}</Typography>}
          </Box>
          <Divider />
          <MenuItem onClick={() => { navigate('/profile'); setAnchorEl(null); }}>
            <PersonIcon fontSize="small" sx={{ mr: 1 }} /> Profile
          </MenuItem>
          <MenuItem onClick={handleLogout}>
            <LogoutIcon fontSize="small" sx={{ mr: 1 }} /> Logout
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};
